import React from 'react';
import { motion } from 'framer-motion';

const PrivacyCatalina = () => {
  return (
    <div className="pt-24 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 legal-content">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <span className="text-accent-emerald font-semibold tracking-wider text-sm uppercase mb-2 block">App Specific Policy</span>
        <h1>Catalina AI Web Builder Privacy Policy</h1>
        <p className="text-sm border-l-2 border-accent-emerald pl-4 mb-8">
          Last Updated: October 2026
        </p>
        <p>
          This document outlines the specific privacy practices for <strong>Catalina AI Web Builder</strong>.
          It serves as an addendum to the general MediaVerse Labs Privacy Policy.
        </p>

        <h2>1. Everything Stays on Your Computer</h2>
        <p>
          Catalina is a desktop application for Windows and Mac. Every website you create is saved on
          your computer as ordinary files. We have no servers holding your work, no cloud copies and no
          accounts. We cannot see your websites, your business details or anything you type.
        </p>

        <h2>2. No Telemetry, No Analytics</h2>
        <p>
          The app contains no telemetry, no analytics and no crash reporting. It does not report
          anything about you or your use of it to MediaVerse Labs or anyone else. There is no
          licensing server: the Microsoft Store or the Mac App Store handles your purchase.
        </p>

        <h2>3. Third-Party AI Providers (Bring Your Own Key)</h2>
        <p>
          To write and illustrate your website with AI, Catalina connects to the provider you
          choose (Google AI Studio, DeepSeek, OpenRouter, or a custom endpoint) using your own API key.
        </p>
        <ul>
          <li><strong>API keys:</strong> stored only on your device, encrypted with your computer's secure storage (Windows data protection or the macOS Keychain). They are sent only to the provider they belong to, never to MediaVerse Labs.</li>
          <li><strong>What is sent:</strong> when you generate or edit with AI, the business details you typed (name, city, services, and your instructions) are sent to your chosen provider. That request is subject to the provider's own privacy policy.</li>
          <li><strong>Nothing is automatic:</strong> data leaves your computer only when you press a button that says so. Before your key is saved, the app asks you to agree to this, naming the provider. The app also works without any key, using built-in content.</li>
        </ul>

        <h2>4. Optional Online Services</h2>
        <p>Each of these runs only when you use the matching feature:</p>
        <ul>
          <li><strong>Photo search:</strong> your search words go to Pixabay to find free stock photos.</li>
          <li><strong>Address search and map:</strong> the business address you type is sent to OpenStreetMap's Nominatim service to find it, and map tiles are fetched from OpenFreeMap to draw it.</li>
          <li><strong>Publishing:</strong> if you connect Netlify, Cloudflare Pages or Vercel, your finished website files are uploaded to that service using a token you provide. The token is stored encrypted on your device.</li>
        </ul>

        <h2>5. Your Visitors' Privacy Too</h2>
        <p>
          The websites Catalina generates contain no tracking, no cookies and no analytics by
          default. Photos and map images are baked into the site as files, so your visitors'
          browsers make no third-party requests.
        </p>

        <h2>6. Data Retention and Deletion</h2>
        <p>
          Since everything lives on your computer, deleting your data is entirely in your hands:
          delete a website from within the app, or remove the Catalina websites folder (File &gt; Open Websites Folder shows where it is).
          On Windows, uninstalling removes the app and your websites stay in your Documents folder
          until you delete them. On Mac, moving the app to the Trash and emptying it removes the
          app; its data folder in your Library can be deleted at the same time.
        </p>

        <h2>7. Contact</h2>
        <p>
          For privacy inquiries: <a href="mailto:support@mediaverselabs.com">support@mediaverselabs.com</a>
        </p>
      </motion.div>
    </div>
  );
};

export default PrivacyCatalina;
